import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap, finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { eLead } from './entities';
import { AlertService } from './alert.service';
import { MasterService } from './master.service';

@Injectable({
  providedIn: 'root',
})
export class VesperService {

  API_ROOT = environment.apiUrlVesper;
  server = this.API_ROOT;
  l_target = '';

  endpoint_auth = 'auth/login';
  endpoint_lead = 'lead/save';
  //endpoint_partner = 'api/partner';
  
  constructor(private http: HttpClient, private _svc_alert: AlertService, private _svc_master: MasterService) {} 

  logmein():void {
    let token = localStorage.getItem('token');
    if (token) console.log('Already in');
    else {
      var cDate = new Date();
      console.log('sending login - ' + cDate.getUTCDate());

      var l_params = { Username: "admin", Password: "123456" }; 

      this.l_target = this.server + this.endpoint_auth;
      
      
      let trythis = this.http
      .post(this.l_target, l_params)
      .pipe(
        map((response: any) => { 
          localStorage.setItem('token', response.token);
        }), 
      ).subscribe({ 
        next: (res) => {  
          console.log('handshake - ok');
        }
      });
    }

  }
  
  send_lead(p_lead:eLead):void {
    let token = localStorage.getItem('token');
    if (token) console.log('Already in');
    else 
      this.logmein();

    var cDate = new Date();
    console.log('sending lead - ' + cDate.getUTCDate());

    var l_params = { name: p_lead.name, phone: p_lead.phone, mail: p_lead.mail };

    this.l_target = this.server + this.endpoint_lead;
    
    let trythis = this.http
    .post(this.l_target, l_params)
    .pipe(
      map((response: any) => response), 
      finalize(() => { this._svc_master.trg_master("loading"); })
    ).subscribe({ 
      next: () => { this._svc_alert.success('ok'); }
      //complete: () => { this._svc_alert.show(); }
    });
  

  }

}
